import $ from 'jquery'

declare global {
  interface JQuery {
    inputmask(mask: string, options?: any): JQuery;
  }
}

export class PostingPeriodField {
  public static get wireup() {
    return '[data-posting-period]';
  }

  public constructor(element: HTMLElement, options?: any) {
    if (!element)
      throw Error('You must provide an element to PostingPeriodField');

    $(element).inputmask('9999-99', {
      placeholder: 'YYYY-MM',
      showMaskOnHover: false,
      clearIncomplete: true
    });
  }

  public static load(element: HTMLElement, options?: any): PostingPeriodField {
    let postingPeriodElement = element as IPostingPeriodElement;
    if (!postingPeriodElement.postingPeriodField)
      postingPeriodElement.postingPeriodField = new PostingPeriodField(postingPeriodElement, options);

    return postingPeriodElement.postingPeriodField;
  }
}

export interface IPostingPeriodElement extends HTMLInputElement {
  postingPeriodField: PostingPeriodField;
}

export default PostingPeriodField;